/**
 * Registrering av service workern.
 *
 * Sökvägen är absolut `/service-worker.js` — INTE `%PUBLIC_URL%`-baserad.
 * PUBLIC_URL är `/stats` (assets ligger där för att inte krocka med Djangos
 * `/static`), men en service worker får bara kontrollera sökvägar under sin
 * egen katalog. En SW under `/stats/` hade alltså inte kunnat hantera push
 * eller navigering för appen, som ligger på roten.
 */

/** @type {string} Sökväg till service workern (rot-scope). */
const SW_PATH = '/service-worker.js';

/**
 * Registrerar service workern om webbläsaren stöder den.
 *
 * Körs efter `load` så registreringen aldrig konkurrerar med den första
 * renderingen om nätverket. Fel loggas men får aldrig krascha appen — en
 * uteblivna registrering betyder bara att push och installation inte är
 * tillgängliga, allt annat fungerar.
 *
 * @returns {void}
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SW_PATH, { scope: '/' }).catch((err) => {
      // Vanligaste orsaken i utveckling: filen saknas och nginx/dev-servern
      // svarar med index.html, som inte går att exekvera som JavaScript.
      console.warn('Service worker kunde inte registreras:', err);
    });
  });
}

/**
 * Returnerar den aktiva service worker-registreringen, eller null.
 *
 * Push-prenumerationen behöver registreringen; den väntar in `ready` så
 * anroparen inte behöver bry sig om att installationen kan vara pågående.
 *
 * @returns {Promise<ServiceWorkerRegistration|null>}
 */
export async function getServiceWorkerRegistration() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return null;
  try {
    return await navigator.serviceWorker.ready;
  } catch (e) {
    return null;
  }
}
